import { Stack, TextField} from "@mui/material"
import { dateFormmater } from "../../../helpers";

export const NextCallFilter = ({ setFilterArray, copyArray }) => {

    const handleSubmit = (e) => {
        e.preventDefault();
        const filter = e.target.value.toUpperCase();

        const newFilterArray = copyArray?.filter((row) =>  row.addressWork?.toUpperCase().includes(filter) || row.contact?.toUpperCase().includes(filter) || dateFormmater(row.dateCall).includes(filter));
        setFilterArray(newFilterArray)
    }

    return (
        <Stack component='form' flexDirection='row' justifyContent='space-between' width='100%' mb='1rem' >
            <TextField
                label="Filtrar por dirección, contacto o fecha (dd/mm/yyyy)"
                defaultValue=""
                size="small"
                name="filter"
                sx={{width:'100%'}}
                onChange={handleSubmit}
            />

        </Stack>
    )
}

